import { t } from '$i18n'
import {
  BackpackOutlinedIcon,
  JaryanOutlinedIcon,
  ShoeprintOutlinedIcon,
  StationsOutlinedIcon,
} from '@weblite/icons'
import {
  switchToJaryan,
  switchToKooleh,
  switchToMavakeb,
  switchToRahkar,
} from '$logic/router'
import { StaticPanelWappId } from '$logic/wapp-panels'

export const navigationStaticWapps = [
  {
    name: t('navigationBar.backpack'),
    icon: <BackpackOutlinedIcon />,
    onClick: switchToKooleh,
    wId: StaticPanelWappId.KOOLEH,
  },
  {
    name: t('navigationBar.stream'),
    icon: <JaryanOutlinedIcon />,
    onClick: switchToJaryan,
    wId: StaticPanelWappId.JARYAN,
  },
  {
    name: t('navigationBar.movement'),
    icon: <ShoeprintOutlinedIcon />,
    onClick: switchToRahkar,
    wId: StaticPanelWappId.RAHKAR,
  },
  {
    name: t('navigationBar.stations'),
    icon: <StationsOutlinedIcon />,
    onClick: switchToMavakeb,
    wId: StaticPanelWappId.MAVAKEB,
  },
]
